export const allReasons = [
  { value: "not_qualified", label: "Not Qualified" },
  { value: "failed_background_check", label: "Failed Background Check" },
  { value: "unreachable", label: "Unreachable" },
  { value: "no_show", label: "No Show" },
  { value: "withdrew", label: "Withdrew Application" },
  { value: "other", label: "Other" },
  { value: "waiting_list", label: "Waiting List / Capacity Hold" },
  { value: "pending_documentation", label: "Pending Documentation" },
  { value: "no_show_reschedule", label: "No Show – Awaiting Reschedule" },
  { value: "delayed_start", label: "Delayed Start by Candidate" },
  { value: "licence_utr_issues", label: "Licence/UTR Issues" },
]

// Reusable subsets for stage-specific dialogs
export const rejectionReasons = [
  { value: "not_qualified", label: "Not Qualified" },
  { value: "failed_background_check", label: "Failed Background Check" },
  { value: "unreachable", label: "Unreachable" },
  { value: "no_show", label: "No Show" },
  { value: "withdrew", label: "Withdrew Application" },
  { value: "other", label: "Other" },
]

export const holdReasons = [
  { value: "waiting_list", label: "Waiting List / Capacity Hold" },
  { value: "pending_documentation", label: "Pending Documentation" },
  { value: "no_show_reschedule", label: "No Show – Awaiting Reschedule" },
  { value: "delayed_start", label: "Delayed Start by Candidate" },
  { value: "licence_utr_issues", label: "Licence/UTR Issues" },
  { value: "other", label: "Other" },
]

// Configuration for different application stage dialog types
export const stageDialogConfig = {
  rejection: {
    title: "Rejection Reason",
    description: "Please select a reason for rejecting this applicant.",
    reasons: rejectionReasons,
    confirmButtonText: "Reject Applicant",
    stage: "rejected",
  },
  hold: {
    title: "Hold Reason",
    description: "Please select a reason for putting this applicant on hold.",
    reasons: holdReasons,
    confirmButtonText: "Put on Hold",
    stage: "hold",
  },
}

export type StageDialogType = keyof typeof stageDialogConfig
